import { Header } from '../../../../components/common/table/Header/Header';
import { HeaderCell } from '../../../../components/common/table/HeaderCell/HeaderCell';
import '../EventList.scss';

export interface EventListHeaderProps {}

export function EventListHeader() {
  return (
    <Header>
      <HeaderCell>{'time stamp'}</HeaderCell>
      <HeaderCell>{'status'}</HeaderCell>
      <HeaderCell>{'plan name'}</HeaderCell>
      <HeaderCell>{'station'}</HeaderCell>
      <HeaderCell>{'patient id'}</HeaderCell>
      <HeaderCell>{'machine'}</HeaderCell>
    </Header>
  );
}
